export const HEADER_HEIGHT = 55;
export const CANDIDATE_LIST_Y_PADDING = 12;
export const CANDIDATE_ITEM_PADDING = 8;
export const CANDIDATE_ITEM_MIN_WIDTH = 50;
export const CANDIDATE_ITEM_MAX_WIDTH = 75;
export const CANDIDATE_ITEM_HEIGHT = 112;
export const CANDIDATE_ITEM_THUMB_SIZE = 40;
export const CANDIDATE_ITEM_THUMB_BORDER_WIDTH = 4;
export const CANDIDATE_OVERVIEW_HEIGHT = 125;
